import { render, staticRenderFns } from "./experience-address.vue?vue&type=template&id=6a548360"
import script from "./experience-address.vue?vue&type=script&lang=ts"
export * from "./experience-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/vercel/path0/components/ui/input.vue').default})
